'use strict';
import 'url-search-params-polyfill'; // IE-11

export default (API) => ({
    other: {
        sendReminders: (establishmentId, params) => {
            const request = API.http.post(`/v3/establishments/${establishmentId}/reminders`, params);
            return API.handleError(request);
        },
        confirmAppointment: (params) => {
            const request = API.http.post('/v3/confirmAppointment', params);
            return API.handleError(request);
        },
        cancelAppointment: (params) => {
            const request = API.http.post('/v3/cancelAppointment', params);
            return API.handleError(request);
        },
        sendJoinUsMail: (params) => {
            const request = API.http.post('/v3/joinUs', params);
            return API.handleError(request);
        },
        sendCouponLostMail: (establishmentId, params) => {
            const request = API.http.post(`/v3/establishments/${establishmentId}/couponLost`, params);
            return API.handleError(request);
        },
        geocode: (address) => {
            const request = API.http.get(`/v3/geocode?address=${address}`);
            return API.handleError(request);
        },
        geocoder: (zipcode) => {
            const request = API.http.get(`/v3/geocoder?zipcode=${zipcode}`);
            return API.handleError(request);
        },
    },
});
